export const usePackagePageV3 = () => true;
